module.exports = __webpack_public_path__ + "img/feature_buy_th.e8b21d48.png";